import { render, staticRenderFns } from "./search-comp.vue?vue&type=template&id=5e587bb7&scoped=true&"
import script from "./search-comp.vue?vue&type=script&lang=js&"
export * from "./search-comp.vue?vue&type=script&lang=js&"
import style0 from "./search-comp.vue?vue&type=style&index=0&id=5e587bb7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e587bb7",
  null
  
)

export default component.exports